import * as React from "react";
const SvgFiRrBoxOpen = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-box-open_svg__a)">
      <path
        fill="#062147"
        d="M23.622 6.836 22.27 4.01a3.02 3.02 0 0 0-1.758-1.552L14.214.359a7.04 7.04 0 0 0-4.428 0L3.49 2.458a3.02 3.02 0 0 0-1.759 1.554L.445 6.719a3.01 3.01 0 0 0-.247 2.609c.31.84.964 1.49 1.802 1.796l-.005 6.314a4.99 4.99 0 0 0 3.418 4.748l4.365 1.455a7 7 0 0 0 2.214.357c.75 0 1.5-.119 2.214-.357l4.37-1.457a4.99 4.99 0 0 0 3.418-4.739l.006-6.32a2.98 2.98 0 0 0 1.819-1.79c.317-.858.229-1.8-.197-2.5M10.42 2.256a5.03 5.03 0 0 1 3.162.001l4.247 1.416-5.821 1.95-5.835-1.95zm-8.216 5.41 1.327-2.782c.048.025 7.057 2.373 7.057 2.373l-1.62 3.258a1.006 1.006 0 0 1-1.174.434l-5.08-1.693a1.02 1.02 0 0 1-.64-.619c-.109-.294-.078-.616.13-.97zm3.841 12.623a2.995 2.995 0 0 1-2.05-2.848l.004-5.648 3.162 1.054c1.344.448 2.792-.087 3.56-1.371l.277-.557-.005 10.981a5 5 0 0 1-.58-.155L6.046 20.29zm11.897-.001-4.37 1.457a5 5 0 0 1-.58.155l.004-10.995.32.64a2.98 2.98 0 0 0 3.52 1.302l3.162-1.053-.006 5.651a3 3 0 0 1-2.052 2.844zm4-11.644a1 1 0 0 1-.619.6l-5.117 1.706c-.438.147-.934-.035-1.136-.365l-1.655-3.323s7.006-2.351 7.054-2.377l1.392 2.901a1 1 0 0 1 .081.859z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-box-open_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrBoxOpen;
